var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.75,
    y: 6.17822,
    width: 16.5,
    height: 13.9286,
    rx: 2.25,
    stroke: "#1A1B1D",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 10.5713H3",
    stroke: "#1A1B1D",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.89282 4.14244C8.89282 3.72823 8.55704 3.39244 8.14282 3.39244C7.72861 3.39244 7.39282 3.72822 7.39282 4.14244L8.89282 4.14244ZM8.14282 4.14244L7.39282 4.14244L7.39282 6.71387L8.14282 6.71387L8.89282 6.71387L8.89282 4.14244L8.14282 4.14244Z",
    fill: "#1A1B1D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6072 4.14244C16.6072 3.72823 16.2714 3.39244 15.8572 3.39244C15.443 3.39244 15.1072 3.72822 15.1072 4.14244L16.6072 4.14244ZM15.8572 4.14244L15.1072 4.14244L15.1072 6.71387L15.8572 6.71387L16.6072 6.71387L16.6072 4.14244L15.8572 4.14244Z",
    fill: "#1A1B1D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.8005792bf54e909ae7a4af43f7ede4ce.svg";
export { ForwardRef as ReactComponent };